import { getCreatorHandle } from "../../../lib/constants";
import { IParseCreatorsGoogleSheetRequest } from "@shared/lib/types/brief";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import styles from "../errors.module.scss";

interface ErrorListProps {
  rows: IParseCreatorsGoogleSheetRequest[];
}

export function ErrorList({ rows }: ErrorListProps) {
  if (rows.length === 0) {
    return (
      <div className={styles.emptyState}>
        <CheckCircle2 size={28} className={styles.emptySuccessIcon} />
        <p className={styles.emptyTitle}>All good — nothing failed</p>
        <p className={styles.emptySubtitle}>
          Every row in the sheet is ready to import.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.reviewTable}>
      <div className={styles.errorBanner}>
        These won’t be added. Fix them in your sheet and re-upload, or continue
        with the ready creators only.
      </div>
      <div className={styles.errorList}>
        {rows.map((row, idx) => (
          <div
            key={`${row.rowNumber}-${row.username}-${idx}`}
            className={styles.errorItem}
          >
            <div className={styles.errorRowLabel}>Row {row.rowNumber || idx + 1}</div>
            <div className={styles.errorItemBody}>
              <div className={styles.creatorName}>
                {row.username ? (
                  getCreatorHandle(row)
                ) : (
                  <span className={styles.emptyValue}>Empty handle</span>
                )}
              </div>
              <div className={styles.creatorHandle}>
                {row.platform || "No platform"}
              </div>
            </div>
            <div className={styles.errorReasonBadge}>
              <AlertCircle size={13} />
              <span>{row.message || "Invalid row"}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
